// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-user-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  min-height: 100vh;
  margin-top: 1vh;
}

.admin-user-page-section {
  padding: 8px;
}

.admin-user-page-heading {
  display: flex;
  justify-content: center;
  align-self: center;
  padding: 8px;
  font-size: 1.75rem;
  color: white;
}

.admin-user-table-container {
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto;
  padding: 8px;
}

.admin-user-table {
  width: 75vw;
  border-collapse: collapse;
}

.admin-user-table-header {
  background-color: #e2e2e2;
  font-size: 1.5rem;
}

.admin-user-table-header th {
  color: #247a97;
}

.admin-user-table-row {
  cursor: pointer;
  text-align: center;
  font-size: 1.25rem;

  &:hover {
    background-color: #f0f0f0;
  }
}

.admin-user-avatar {
  height: 52px;
  width: 52px;
  border-radius: 50%;
  overflow: hidden;
  margin-top: 1rem;
}

.admin-user-avatar img {
  height: 100%;
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

.admin-user-details-section {
  padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminUserPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".admin-user-page-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: top;\n  width: 100%;\n  min-height: 100vh;\n  margin-top: 1vh;\n}\n\n.admin-user-page-section {\n  padding: 8px;\n}\n\n.admin-user-page-heading {\n  display: flex;\n  justify-content: center;\n  align-self: center;\n  padding: 8px;\n  font-size: 1.75rem;\n  color: white;\n}\n\n.admin-user-table-container {\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow-x: auto;\n  padding: 8px;\n}\n\n.admin-user-table {\n  width: 75vw;\n  border-collapse: collapse;\n}\n\n.admin-user-table-header {\n  background-color: #e2e2e2;\n  font-size: 1.5rem;\n}\n\n.admin-user-table-header th {\n  color: #247a97;\n}\n\n.admin-user-table-row {\n  cursor: pointer;\n  text-align: center;\n  font-size: 1.25rem;\n\n  &:hover {\n    background-color: #f0f0f0;\n  }\n}\n\n.admin-user-avatar {\n  height: 52px;\n  width: 52px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-top: 1rem;\n}\n\n.admin-user-avatar img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.admin-user-details-section {\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
